export const appSettingsCustomAttributesTags = "/app_settings/custom_attributes_tags";
